// お見積りリクエスト (/pages/estimate). Chờ ink:api:ready → đọc
// /cart.js render preview + gửi sku/qty/children lên POST /estimates (totals
// recompute server-side, faithful). §JPY: giá /cart.js ×100 → /100 +
// toLocaleString. §Processing: nút submit hiện 処理中 qua window.inkProcessing.

(function () {
  'use strict';

  function boot() {
    const root = document.querySelector('[data-ink-estimate]');
    if (!root) return;

    const cfg = window.INK_ESTIMATE || {};
    const thankyouUrl = cfg.thankyouUrl || '/pages/estimate-thankyou';
    const fmt = (n) => Number(n || 0).toLocaleString('ja-JP');
    const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

    const emptyEl = root.querySelector('[data-estimate-empty]');
    const mainEl = root.querySelector('[data-estimate-main]');
    const linesEl = root.querySelector('[data-estimate-lines]');
    const subtotalEl = root.querySelector('[data-estimate-subtotal]');
    const form = root.querySelector('[data-estimate-form]');
    const msg = form ? form.querySelector('[data-estimate-message]') : null;
    const submitBtn = form ? form.querySelector('[data-estimate-submit]') : null;
    const secCorp = root.querySelector('[data-section-corporate]');
    const secInd = root.querySelector('[data-section-individual]');

    // Message đỏ (lỗi) / xanh (thành công)
    function setMsg(text, ok) {
      if (!msg) return;
      msg.className = (ok ? 'text-[#1a8000]' : 'text-[#e60012]') + ' text-sm mb-3 min-h-[18px]';
      msg.textContent = text;
    }
    // Ép browser download blob (mirror Joomla 発行 → xuất file)
    function triggerDownload(blob, filename) {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    }

    // Cart lines gửi lên backend (sku/qty/children — như cart.js gather).
    let cartItems = [];

    // ===== 1. Đọc /cart.js → preview + payload =====
    (async () => {
      let cart;
      try {
        cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then((r) => r.json());
      } catch (e) {
        // Fail-open: cho phép form hiện (backend validate items rỗng → 422).
        if (mainEl) mainEl.hidden = false;
        return;
      }

      if (!cart || !cart.items || cart.items.length === 0) {
        if (emptyEl) emptyEl.hidden = false;
        return;
      }
      if (mainEl) mainEl.hidden = false;

      let subtotal = 0;
      const rows = [];
      cart.items.forEach((it) => {
        if (!it.sku) return;
        // Line quà (_gift) = ¥0 (ink-discount Function zero ở checkout). Giá gốc
        // của variant KHÔNG được dùng — cả preview lẫn payload phải là 0, nếu không
        // 見積書 tính quà thành tiền.
        const isGift = !!(it.properties && it.properties._gift === '1');
        const unit = isGift ? 0 : Math.round((it.final_price || it.price || 0) / 100); // §JPY ×100 → yen
        const line = unit * it.quantity;
        subtotal += line;
        rows.push(`<tr>
          <td class="p-2">${esc(it.product_title || it.title)}<br><span class="text-[12px] text-[#888]">SKU: ${esc(it.sku)}</span></td>
          <td class="p-2 text-right">${it.quantity}</td>
          <td class="p-2 text-right">￥${fmt(unit)}</td>
          <td class="p-2 text-right">￥${fmt(line)}</td>
        </tr>`);

        const item = { sku: it.sku, qty: it.quantity };
        if (isGift) item.is_gift = true;
        const mm = it.properties && it.properties._mix_match_skus;
        if (mm) { try { item.children = JSON.parse(mm); } catch (e) { /* breakdown hỏng → bỏ children */ } }
        cartItems.push(item);
      });
      if (linesEl) linesEl.innerHTML = rows.join('');
      if (subtotalEl) subtotalEl.textContent = '￥' + fmt(subtotal);
    })();

    // ===== 2. Auto-fill từ profile (logged-in) =====
    (async () => {
      if (!form || !window.inkApi || !window.inkApi.me) return;
      try {
        const u = await window.inkApi.me();
        const d = (u && (u.data || u)) || {};
        if (d.company) {
          form.elements.kind.value = '0';
          form.elements.company.value = d.company;
          if (form.elements.brew) form.elements.brew.value = d.cc_brew || d.brew || '';
          toggleKind('0');
        } else if (d.last_name || d.name) {
          form.elements.kind.value = '1';
          form.elements.name.value = d.last_name || d.name || '';
          toggleKind('1');
        }
      } catch (e) { /* guest → để trống */ }
    })();

    // ===== 3. Toggle fieldset theo kind =====
    function toggleKind(kind) {
      if (secCorp) secCorp.hidden = kind !== '0';
      if (secInd) secInd.hidden = kind !== '1';
    }
    if (form) {
      form.querySelectorAll('input[name="kind"]').forEach((r) => {
        r.addEventListener('change', (e) => toggleKind(e.target.value));
      });
    }

    // ===== 4. Submit =====
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (!msg) return;
        setMsg('', false);

        const kind = form.querySelector('input[name="kind"]:checked');
        const kindVal = kind ? kind.value : '';
        if (kindVal === '0' && !form.elements.company.value.trim()) {
          setMsg('会社名を入力してください。', false); return;
        }
        if (kindVal === '1' && !form.elements.name.value.trim()) {
          setMsg('お名前を入力してください。', false); return;
        }
        if (cartItems.length === 0) {
          setMsg('見積もり対象の商品がありません。', false); return;
        }

        const payload = {
          kind: parseInt(kindVal, 10),
          company: form.elements.company ? form.elements.company.value.trim() || null : null,
          brew: form.elements.brew ? form.elements.brew.value.trim() || null : null,
          name: form.elements.name ? form.elements.name.value.trim() || null : null,
          items: cartItems,
        };

        window.inkProcessing?.show('お見積書を作成中...');
        if (submitBtn) submitBtn.disabled = true;
        try {
          const res = await window.inkApi.post('/estimates', payload);
          const id = res && res.data && res.data.estimate_id;
          if (!id) {
            setMsg(errorMessage(res), false);
            return;
          }
          // 発行 → download PDF ngay (mirror Joomla: bấm phát hành = xuất PDF).
          try {
            const blob = await window.inkApi.fetchBlob('/estimates/' + encodeURIComponent(id) + '/preview');
            triggerDownload(blob, 'お見積書_' + id + '.pdf');
            setMsg('お見積書（' + id + '）をダウンロードしました。', true);
          } catch (dlErr) {
            console.warn('[estimate] pdf download failed', dlErr);
            setMsg('お見積書を作成しました（番号 ' + id + '）。ダウンロードに失敗した場合はマイページからご確認ください。', true);
          }
        } catch (err) {
          console.warn('[estimate] submit failed', err);
          setMsg('送信に失敗しました。時間をおいて再度お試しください。', false);
        } finally {
          window.inkProcessing?.hide();
          if (submitBtn) submitBtn.disabled = false;
        }
      });
    }

    function errorMessage(res) {
      if (res && res.error && res.error.message) return res.error.message;
      if (res && res.errors) {
        const first = Object.values(res.errors)[0];
        if (Array.isArray(first) && first.length) return first[0];
      }
      return '送信に失敗しました。入力内容をご確認ください。';
    }
  }

  let booted = false;
  function startOnce() { if (booted) return; booted = true; boot(); }
  if (window.inkApi) startOnce();
  else {
    document.addEventListener('ink:api:ready', startOnce, { once: true });
    window.addEventListener('load', () => setTimeout(() => { if (!window.inkApi) startOnce(); }, 1000));
  }
})();
